export default __webpack_public_path__ + "static/media/spicy-arriva.be21c743.jpeg";